window.theme = window.theme || {} ;
theme.tab_content = function(){
  var tab_heading = document.querySelectorAll('.tab-head');
  tab_heading.forEach(button => button.addEventListener('click',function(){
    var index = this.getAttribute('data-index');
    var closest = this.closest('.tab-content-main-wrapper');
    closest.querySelectorAll('.tab-head').forEach(function(item){
      item.classList.remove('active');
    });
    closest.querySelectorAll('.tab-content').forEach(function(item){
      item.style.display = 'none';
    });
    closest.querySelector(`.tab-head[data-index='${index}']`).classList.add('active');
    closest.querySelector(`.tab-content[data-index='${index}']`).style.display = 'block';
    var closest_classlist = $(this).closest('.tab-content-main-wrapper');
    console.log("closessst",$(closest_classlist).find('.tab-content:visible .plans-slider'));
    if($(closest_classlist).find(`.tab-content:visible .plans-slider.slick-initialized`).length > 0){
      $(closest_classlist).find('.tab-content:visible .plans-slider').slick('unslick');
      $(closest_classlist).find('.tab-content:visible .plans-slider').resize();
    }
    theme.match_media_plan(closest_classlist);
  }));
};
theme.custom_banner_slider = function(){
  $('.custom_banner_slider').slick({
    infinite: true,
    dots:true,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>'
  });
};
// theme.custom_megamenu_click = function(){
//   $(".custom_mega_menu .header__menu-item").on("click", function(){
//       $(this).closest(".custom_mega_menu").toggleClass("active");
//   });
// };
theme.plans_tab_slider = function(closest){
  $(closest).find('.tab-content:visible .plans-slider').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows:false,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows:false
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
}
theme.match_media_plan = function(closest){
  if (window.matchMedia("(max-width: 749px)").matches) {
    if($(closest).find('.tab-content:visible .plans-slider').data('collection-size') > 1 ){
      // console.log("749");
      theme.plans_tab_slider(closest);
    }
  }else if(window.matchMedia("(max-width: 989px)").matches && window.matchMedia("(min-width: 748px)").matches){
    if($(closest).find('.tab-content:visible .plans-slider').data('collection-size') > 2 ){
      // console.log("989 748");
      theme.plans_tab_slider(closest);
    }
  }else{
    if($(closest).find('.tab-content:visible .plans-slider').data('collection-size') > 3 ){
      // console.log("dektop");
      theme.plans_tab_slider(closest);
    }
  }
}

theme.getUrlFilterMap = function(){
  const currentUrl = window.location.href;
  getUrlParameter(currentUrl);

  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  // Check if the "availability" parameter is true
  var availability = getUrlParameter('availability');
  if (availability === 'true') {
    // Add a class to the body
    document.body.classList.add('filter_avilable_top');
  }
}

theme.coveragePageLoader = function(){
  window.addEventListener('load', function() {
    document.getElementById('coverage_loader') ? document.getElementById('coverage_loader') .style.display = 'none' : '';
    document.getElementById('ucmMap') ? document.getElementById('ucmMap').style.display = 'flex' : '' ;
  });

  // Hide loader when page finishes loading
  window.addEventListener('DOMContentLoaded', function() {
    document.getElementById('coverage_loader') ? document.getElementById('coverage_loader').style.display = 'block' : '';
    document.getElementById('ucmMap') ? document.getElementById('ucmMap').style.display = 'none' : '';
  });
}
theme.coverage_orderNow_click = function(){
  document.querySelector('.has_product_available').addEventListener('click',function(e){
    // e.preventDefault();
    console.log('payload',theme.result_payload_data.results.items[0].payload);
    let shop = Shopify.shop , 
    country= theme.result_payload_data.results.items[0].payload.AddressInfo.LR_COUNTRY ,
    city = theme.result_payload_data.results.items[0].payload.AddressInfo.LR_TOWN ,
    amid = theme.result_payload_data.results.items[0].payload.AMID ,
    suburb =theme.result_payload_data.results.items[0].payload.AddressInfo.LR_SUBURB ,
    street1 = theme.result_payload_data.results.items[0].payload.AddressInfo.LR_STREET ,
    region = theme.result_payload_data.results.items[0].payload.AddressInfo.REGION ,
    longitude = theme.result_payload_data.results.items[0].payload.LON ,
    latitude = theme.result_payload_data.results.items[0].payload.LAT,
    buildingName = theme.result_payload_data.results.items[0].payload.buildingNumberInfo?.buildingInfo[0].BUILDING_NAME ,
    floor = theme.result_payload_data.results.items[0].payload.buildingNumberInfo?.buildingInfo[0].FLOOR ,
    unit = theme.result_payload_data.results.items[0].payload.buildingNumberInfo?.buildingInfo[0].NUM ;
    let compareProducts = localStorage.getItem('locationData');
    theme.locationData = JSON.parse(compareProducts) || {};
    theme.locationData = {
      shop: shop,
      country: country,
      city: city,
      buildingName:buildingName,
      floor: floor ,
      unit: unit ,
      amid:amid ,
      suburb: suburb ,
      street1: street1,
      region:region ,
      longitude: longitude,
      latitude: latitude
    };
    console.log('locationData',theme.locationData);
    // // Convert the array to a JSON string
    // var jsonStr = JSON.stringify(locationData);

    // Store the JSON string in localStorage
    localStorage.setItem("locationData", JSON.stringify(theme.locationData));
   });
}
theme.data_post = function(){
  let location_data = JSON.parse(localStorage.getItem('locationData'));
  console.log('location_data',location_data);
  const formdata = new FormData();
  formdata.append("shop", location_data.shop);
  formdata.append("country", location_data.country);
  formdata.append("city", location_data.city);
  formdata.append("buildingName",location_data.buildingName);
  formdata.append("floor", location_data.floor);
  formdata.append("unit", location_data.unit);
  formdata.append("amid", location_data.amid);
  formdata.append("suburb", location_data.suburb);
  formdata.append("street1", location_data.street1);
  formdata.append("region", location_data.region);
  formdata.append("longitude",location_data.longitude);
  formdata.append("latitude", location_data.latitude);
  console.log('formdata',formdata);
  const settings = {
    "url": "https://ml-conventions-terminals-telling.trycloudflare.com/api/storeAddress",
    "method": "POST",
    "timeout": 0,
    "processData": false,
    "mimeType": "multipart/form-data",
    "contentType": false,
    "dataType": "json",
    "data": formdata
  };

  // $.ajax(settings).done(function (response) {
  //   console.log('response',response);
  // });
}

theme.ticket_data_list_api = function(){
  console.log("ticket data api called");
  // if customer is login ticket list
  const formdata = new FormData();
  let shop_name = 'hetarth-brahmbhatt.myshopify.com' ;
  let customer_id = '12345';
  console.log('formdata',formdata);
  const settings = {
    "url": `https://ec-webmaster-panama-ought.trycloudflare.com/api/ticketList/?customerId=${customer_id}&shop=${shop_name}`,
    "method": "GET",
    "timeout": 0,
    "processData": false,
    "mimeType": "multipart/form-data",
    "contentType": false,
    "dataType": "json",
    "data": formdata
  };

  $.ajax(settings).done(function (response) {
    console.log('response',response);
    let response_dataList = response.data , parentNode = document.getElementById('customer_ticket_list') ;
    let tbody_html = '', table_html = '';
    console.log('response_dataList',response_dataList);
    if(response_dataList != null || response_dataList != '' ){
      console.log("not null");
      response_dataList.forEach(function(item,index){
        console.log('item',item.id);
        tbody_html += `<tr> <td>${item.ticket_id}</td> <td>${item.type}</td> <td>${item.status}</td> <td>${item.created_at}</td> </tr>`
      });
      table_html = `<table width="100%" border="1"> <thead> <tr> <th>Ticket Id</th> <th>Type</th> <th>status</th> <th>Created At</th> </tr> </thead> <tbody> ${tbody_html} </tbody> </table>`
      parentNode.innerHTML = table_html;
    }else{
      console.log("null");
    }
  });
}
theme.ticket_form_submit_api = function(){
  var form =document.getElementById('ticket-form');
  // Add submit event listener to the form
  form?.addEventListener('submit', function(event) {
    event.preventDefault();
    // Get form data
    console.log("form submit called");
    var get_formData = new FormData(form);
    const formdata = new FormData();
    formdata.append("first_name", get_formData.get('first_name'));
    formdata.append("last_name", get_formData.get('last_name'));
    formdata.append("contact_no", get_formData.get('contact_no'));
    formdata.append("ticket_type", get_formData.get('ticket_type'));
    formdata.append("priority", get_formData.get('priority'));
    formdata.append("urgency", get_formData.get('urgency'));
    formdata.append("severity", get_formData.get('severity'));
    formdata.append("category", get_formData.get('category'));
    formdata.append("cause", get_formData.get('cause'));
    formdata.append("subject", get_formData.get('subject'));
    formdata.append("escalation_indicator", get_formData.get('escalation_indicator'));
    formdata.append("direct_routing", get_formData.get('direct_routing'));
    formdata.append("shop", Shopify.shop);
    formdata.append("ticket_status", 'Submitted');
    console.log('formdata',formdata);
    const settings = {
      "url": "https://ec-webmaster-panama-ought.trycloudflare.com/api/createTicket",
      "method": "POST",
      "timeout": 0,
      "processData": false,
      "mimeType": "multipart/form-data",
      "contentType": false,
      "dataType": "json",
      "data": formdata
    };
  
    $.ajax(settings).done(function (response) {
      console.log('response',response);
      // form.submit();
    });
  });
}
theme.rica_document_submit = function(){
  var form =document.getElementById('rica-document-submit');
  // Add submit event listener to the form
  form?.addEventListener('submit', function(event) {
    let main_loader =  document.querySelector('.loader');
    main_loader.style.display = 'inline-block';
    document.querySelector('.main-document-submit-wrapper .btn-loader-wrap .button-submit').style.fontSize = '0' ;
    event.preventDefault()
    var get_formData = new FormData(form);
    const formdata = new FormData();
    formdata.append("shop",Shopify.shop);
    formdata.append("customer_id",window.customerId);
    formdata.append("name", get_formData.get('name'));
    formdata.append("email", get_formData.get('email'));
    formdata.append("phone", get_formData.get('phone'));
    formdata.append("account_number", get_formData.get('account_number'));
    formdata.append("id_document", get_formData.get('id_document'));
    formdata.append("address_document", get_formData.get('address_document'));
    formdata.append("consent", get_formData.get('consent'));
    console.log('formdata',formdata);
    const settings = {
      "url": "http://quadstore.openserve.co.za/api/submitDocument",
      "method": "POST",
      "timeout": 0,
      "processData": false,
      "mimeType": "multipart/form-data",
      "contentType": false,
      "dataType": "json",
      "data": formdata
    };
    let message_display = document.querySelector('.form-success-response') ,
    phone_text = document.querySelector('.phone-form-error') ,
    email_text = document.querySelector('.email-form-error');
    $.ajax(settings).done(function (response) {
        console.log('response',response);
        console.log('response',response.message);
        let form_responseMessage = response.message ;
        phone_text.innerText = ' ' ;
        email_text.innerText = ' ' ;
        message_display.innerText = form_responseMessage ;
        setTimeout(() => {
          message_display.innerText = ' ';
        }, 5000);
        message_display.scrollIntoView({ behavior: "smooth", block: "center" });
        const inputs = form.querySelectorAll("input");
        // inputs.forEach(function(item,index){
        //   if (item.type === "checkbox") {
        //       item.checked = false;
        //   } else {
        //       item.value = "";
        //   }
        // });
        document.querySelector('.loader').style.display = 'none';
        document.querySelector('.main-document-submit-wrapper .btn-loader-wrap .button-submit').style.fontSize = '16px' ;
        // after submit function call.
        theme.rica_after_submit();
        setTimeout(() => {
          if ( window.getCookie('login_button_click') ) {
            const url_redirect = window.getCookie('login_button_click');
            window.setCookie('login_button_click', '', 0);
            window.location.href = url_redirect;
          } else {
            window.location.href = '/account';
          }
        }, 1000);
      })
    .fail(function(jqXHR, textStatus, errorThrown) {
      console.error("API call failed: ", textStatus, errorThrown);
      console.log('jqXHR.responseText',jqXHR.responseText);
      let jsonResponse = JSON.parse(jqXHR.responseText) ,
      phone = jsonResponse.message.phone ,
      email = jsonResponse.message.email;
      console.log('phone',phone);
      console.log('email',email);
      message_display.innerText = ' ';
      if(phone != undefined && email != undefined){
        phone_text.innerText = phone ;
        email_text.innerText = email ;
        phone_text.scrollIntoView({ behavior: "smooth", block: "center" });
      }else if(phone != undefined){
        phone_text.innerText = phone ;
        phone_text.scrollIntoView({ behavior: "smooth", block: "center" });
      }else if(email != undefined){
        email_text.innerText = email ;
        email_text.scrollIntoView({ behavior: "smooth", block: "center" });
      }else{
        phone_text.innerText = ' ' ;
        email_text.innerText = ' ' ;
      }
      document.querySelector('.loader').style.display = 'none';
      document.querySelector('.main-document-submit-wrapper .btn-loader-wrap .button-submit').style.fontSize = '16px' ;
    });
  })
}
function validateFileSize(input) {
  const maxFileSize = 2 * 1024 * 1024; // 2 MB (in bytes)
  let document_error = input.parentElement.querySelector('.form-error');
  if (input.files && input.files[0]) {
    const fileSize = input.files[0].size;
    if (fileSize > maxFileSize) {
      document_error.innerText = "File size exceeds the maximum limit of 2MB" ;
      input.value = ''; // Clear the file input
    }else{
      document_error.innerText = ' ';
    }
  }
}
theme.rica_after_submit =  function(){
  const formdata = new FormData();
  formdata.append("customer_id", '7403175903472');
  console.log('formdata',formdata);
  const settings = {
    "url": "http://quadstore.openserve.co.za/api/getDocument",
    "method": "POST",
    "timeout": 0,
    "processData": false,
    "mimeType": "multipart/form-data",
    "contentType": false,
    "dataType": "json",
    "data": formdata
  };
  $.ajax(settings).done(function (response) {
    console.log('response',response);
    if(response.success == true){
      if(window.location.pathname.includes('document-submit')){
        let main_document_wrapper = document.querySelector('.document-detail');
        document.getElementById('phone').setAttribute("value",response.data.phone);
        if(response.data.account_number != null){
          document.getElementById('account_number').setAttribute("value",response.data.account_number);
        }
        document.getElementById('consent').checked = true;
        let process_verify = `<div class="form-filled" style="color: #e89528;font-weight: 600;">${response.message}</div>`;
        document.getElementById('rica-document-submit').insertAdjacentHTML('beforebegin',process_verify);
        //id default value set
        const existing_idDoc = document.getElementById('id_document').closest('div').querySelector('.selected_id');
        let id_docName = (response.data.id_document).split('/');
        let id_docUrl = `<a href='${response.data.id_document}' target="_blank">${id_docName[id_docName.length -1]}</a>`;
        existing_idDoc.innerHTML =  id_docUrl;
        //address default value set
        const existing_addDoc = document.getElementById('address_document').closest('div').querySelector('.selected_address');
        let add_docName = (response.data.id_document).split('/');
        let add_docUrl = `<a href='${response.data.id_document}' target="_blank">${add_docName[add_docName.length -1]}</a>`;
        existing_addDoc.innerHTML = add_docUrl;
      }else if(document.body.classList.contains('template-account')){
        let updated_text = `<div class="text form-filled" style="color: #e89528;font-weight: 600;">${response.message}</div>
                            <div class="button-url"><a href="/pages/document-submit" class="button">View Detail</a></div>`
        document.querySelector('.text-btn-wrap').innerHTML = updated_text ;
      }else if(document.body.classList.contains('template-product') || document.body.classList.contains('template-collection')){
        console.log("pdpppp");
        setTimeout(() => {
          document.querySelectorAll('.no-customer-error').forEach(function(item) {
            item.innerHTML = `<a href="/pages/document-submit" style="color: #e89528;font-weight: 600;text-decoration:none;"> Under verification</a>`;
          });
        }, 1000);
      }
    }
  })
}
theme.sf_checkout = function(){
  $('#sf-billing-form').submit(function(e) {
    e.preventDefault();
    let fields = ['firstName','lastName', 'email', 'billing_address1', 'billing_address2', 'billing_state', 'billing_city', 'billing_zip'];

    let form_data = '' , custom_field_data = '';
    fields.forEach(function(field) {
      var value = $('#' + field).val();    
      if (value !== '') {
        form_data += `&ai_${field}=${value}`;
      }
    });
    const custom_prefix = 'ai_custom_fields_';
    if(localStorage.getItem('locationData') != null){
      let location_data = JSON.parse(localStorage.getItem('locationData'));
      custom_field_data += `${custom_prefix}scf_shop_7dc=${location_data.shop}`;
      custom_field_data += `&${custom_prefix}scf_country_du8=${location_data.country}`;
      custom_field_data += `&${custom_prefix}scf_city_86s=${location_data.city}`;
      custom_field_data += `&${custom_prefix}scf_building_name_ge6=${location_data.buildingName}`;
      custom_field_data += `&${custom_prefix}scf_floor_ef9=${location_data.floor}`;
      custom_field_data += `&${custom_prefix}scf_unit_gif=${location_data.unit}`;
      custom_field_data += `&${custom_prefix}scf_amid_fpe=${location_data.amid}`;
      custom_field_data += `&${custom_prefix}scf_suburb_4dr=${location_data.suburb}`;
      custom_field_data += `&${custom_prefix}scf_street_00j=${location_data.street1}`;
      custom_field_data += `&${custom_prefix}scf_region_xnp=${location_data.region}`;
      custom_field_data += `&${custom_prefix}scf_longitude_sym=${location_data.longitude}`;
      custom_field_data += `&${custom_prefix}scf_latitude_bw6=${location_data.latitude}`;
    }
    if(form_data == ''){
      return false;
    }
    if(custom_field_data == ''){
      return false;
    }
    var urlString = window.location.href;
    function getParameters(urlString) {
      var urlParams = new URLSearchParams(urlString.split('?')[1]);  // Get query string parameters
      console.log('urlParams',urlParams);
      var vid = urlParams.get('v_Id');
      var pid = urlParams.get('p_Id');
      return {
        vid: vid,
        pid: pid
      };
    }
    var extractedParams = getParameters(urlString);
    var payLink = `https://quadrupleplay.subscriptionflow.com/en/hosted-page/subscribe/${extractedParams.vid}/product/${extractedParams.pid}?${custom_field_data}`;
    console.log('payLink',payLink)
  
    window.location.href = payLink;

  });
}
theme.append_custom_data_subscription = function(){
  let custom_field_data = '';
  const custom_prefix = 'ai_custom_fields_';
    if(localStorage.getItem('locationData') != null){
      let location_data = JSON.parse(localStorage.getItem('locationData'));
      custom_field_data += `${custom_prefix}scf_shop_7dc=${location_data.shop}`;
      custom_field_data += `&${custom_prefix}scf_country_du8=${location_data.country}`;
      custom_field_data += `&${custom_prefix}scf_city_86s=${location_data.city}`;
      custom_field_data += `&${custom_prefix}scf_building_name_ge6=${location_data.buildingName}`;
      custom_field_data += `&${custom_prefix}scf_floor_ef9=${location_data.floor}`;
      custom_field_data += `&${custom_prefix}scf_unit_gif=${location_data.unit}`;
      custom_field_data += `&${custom_prefix}scf_amid_fpe=${location_data.amid}`;
      custom_field_data += `&${custom_prefix}scf_suburb_4dr=${location_data.suburb}`;
      custom_field_data += `&${custom_prefix}scf_street_00j=${location_data.street1}`;
      custom_field_data += `&${custom_prefix}scf_region_xnp=${location_data.region}`;
      custom_field_data += `&${custom_prefix}scf_longitude_sym=${location_data.longitude}`;
      custom_field_data += `&${custom_prefix}scf_latitude_bw6=${location_data.latitude}`;
    }
  document.querySelectorAll('.btn_subscribe_now').forEach(function(item){
    let current_Url = item.querySelector('a').getAttribute('href');
    let updated_Url = `${current_Url}&${custom_field_data}`;
    console.log('updated_Url',updated_Url);
    item.querySelector('a').href = updated_Url;
  });
}
document.addEventListener("DOMContentLoaded", (event) => {
  theme.coveragePageLoader();
  theme.getUrlFilterMap();
  // theme.match_media_plan();
  theme.tab_content();
  theme.custom_banner_slider();
  // theme.custom_megamenu_click();

  $(".Server_number input").on("keyup change", function(e) {
    if(this.value.length > 0){
      // $(this).closest(".product-form").find(".product-form__buttons .product-form__submit").attr('disabled', false);
      $(this).closest(".product-form").find(".server_number_error").text("");
      $(this).closest(".product-form").find(".verify-service-number").removeAttr("disabled").addClass("align-self-end").removeClass("align-self-center");
      $(this).closest(".product-form").find(".verify-service-number span").text("Verify");
    }
    else{
      // $(this).closest(".product-form").find(".product-form__buttons .product-form__submit").attr('disabled', true);
      $(this).closest(".product-form").find(".server_number_error").text("Please enter service number");
      $(this).closest(".product-form").find(".verify-service-number").attr("disabled", "disabled").removeClass("align-self-end").addClass("align-self-center");
    }
    // console.log(this.value.length);
  })

  if($('.speed-guide-information-section').length > 0){
  const option_1 = document.getElementById("title_mbps");
  const option_2 = document.getElementById("mbps");
  const info_data = document.getElementById("data");
  const bottom_content = document.getElementById("bottom-content");
  const targeted_content = document.getElementById("targeted-customer");
   theme.mbps.map(data => {
      var options = data.option;
      option_1.innerHTML += `<option value="${options}">${options}</option>`;
      var selected_val = document.getElementById("title_mbps").value ;
        if(selected_val == options){
        var option_mbps = data.option1;
        option2_append(option_mbps);
        }
        var selected_val2 = option_2.value ;
        data.mbps_data.map(mbpsd => {
          option2_datachange(mbpsd,selected_val2,selected_val,options);
        });
        bottom_content.innerHTML = `${data.bottom_content}`
   });
   option_1.addEventListener("change", (event) => {
    theme.mbps.map(data => {
       var options = data.option;
       var selected_val = document.getElementById("title_mbps").value ;
       if(selected_val == options){
         option_2.innerHTML = '';
         var option_mbps = data.option1;
         option2_append(option_mbps);
         bottom_content.innerHTML = `${data.bottom_content}`
          data.mbps_data.map(mbpsd => {
           var selected_val2 = option_2.value ;
           option2_datachange(mbpsd,selected_val2,selected_val,options);
         });
       }
    });
   });
   option_2.addEventListener("change", (event) => {
     theme.mbps.map(data => {
       var options = data.option;
         data.mbps_data.map(mbpsd => {
           var selected_val = option_1.value ;
           var selected_val2 = option_2.value ;
           option2_datachange(mbpsd,selected_val2,selected_val,options);
         });
     });
   });
   function option2_append(option_mbps){
      var single_mbps = option_mbps.split(',');
      single_mbps.forEach(function(value,index){
        option_2.innerHTML += `<option value="${value}">${value} <span>mbps</span></option>`;
      })
   }
   function option2_datachange(mbpsd,selected_val2,selected_val,options){
      var data_id =  mbpsd.id;
          if(selected_val == options && selected_val2 == data_id){
            var info1=mbpsd.info1 ,info2=mbpsd.info2 ,info3=mbpsd.info3 ,info4=mbpsd.info4;
            if(info1.includes('|')){
                info1 = info1.split('|');
                var info1_data = `<div>Suggested users:${info1[0]}</div><div>Connected devices:${info1[1]}</div>`;  
            }else{
              var info1_data = `<div>Suggested users:${info1}</div>`;
            }
            if(info2.includes('|')){
              info2 = info2.split('|');
              var info2_data = `<div>Concurrent HD users:${info2[0]}</div><div>Concurrent 4K users:${info2[1]}</div>`;  
            }else{
              var info2_data = `<div>Suggested users:${info2}</div>`;
            }
            if(info3.includes('|')){
              info3 = info3.split('|');
              var info3_data = `<div>Download 1 GB in:${info3[0]}</div><div>Conference call quality:${info3[1]}</div>`;  
            }else{
              var info3_data = `<div>Suggested users:${info3}</div>`;
            }
            if(info4.includes('|')){
              info4 = info4.split('|');
              var info4_data = `<div>Download 50 GB in:${info4[0]}</div><div>Local gaming ping:${info4[1]}</div>`;  
            }else{
              var info4_data = `<div>Suggested users:${info4}</div>`;
            }
            info_data.innerHTML = `<div class="main-info-wrap">
                  <div class="main-info-wrap-inner">
                  <div class="heading">${mbpsd.head1}</div>
                  <img src="${mbpsd.img1}" height="100px" width="100px">
                  <div class="info-data">${info1_data}</div>
                  </div>
                </div>
                <div class="main-info-wrap">
                <div class="main-info-wrap-inner">
                  <div class="heading">${mbpsd.head2}</div>
                  <img src="${mbpsd.img2}" height="100px" width="100px">
                  <div class="info-data">${info2_data}</div>
                  </div>
                </div>
                <div class="main-info-wrap">
                <div class="main-info-wrap-inner">
                  <div class="heading">${mbpsd.head3}</div>
                  <img src="${mbpsd.img3}" height="100px" width="100px">
                  <div class="info-data">${info3_data}</div>
                  </div>
                </div>
                <div class="main-info-wrap">
                <div class="main-info-wrap-inner">
                  <div class="heading">${mbpsd.head4}</div>
                  <img src="${mbpsd.img4}" height="100px" width="100px">
                  <div class="info-data">${info4_data}</div>
                </div>
                </div>`
            targeted_content.innerHTML = `<span class="content-head">Suite to:</span><span class="content">${mbpsd.targeted_customer}</span>`;
          }
   }
  }
  // check wheather iframe loaded or not
  if($('.coverage-main').length > 0)
  {
    const iframe = document.getElementById("map-iframe");
    $(iframe).on('load', function(){
     //your code (will be called once iframe is done loading)
    //  console.log("loadeddd");
     $('.loader-data').remove();
     $(iframe).css('display','block');
   });
  }
  $('.mega-menu #HeaderMenu-fibre-package').on('mouseover',function(){
    // $('#MegaMenu-Content-2').html("helloo");
    var url = `/`;
      $.ajax({
        url: url,
        success: function(data) {
          const html = new DOMParser().parseFromString(data, "text/html");
          var event_list = html.querySelector('.shopify-section-group-header-group.plans-tab .tab-content-main-wrapper');
            document.getElementById('MegaMenu-Content-fiber-package').innerHTML = event_list.outerHTML;
            setTimeout(() => {
               theme.tab_content();
            }, 500);
        }
      });
  });
  //dynamic announcementbar height
  var announcement_height = $('.announcement-bar-section').height();
  $('.search-modal.modal__content.gradient').css('top',announcement_height);
  if(document.body.classList.contains('template-product')){
    var speed_option = document.getElementById("mbps") ,
        place_option = document.getElementById("title_mbps");

    let place_type = document.querySelector('.dynamic-data').getAttribute('data-placeType');
    var capitalizedString = place_type.toLowerCase().replace(/\b\w/g, function(word) {return word.toUpperCase();});
    place_option.value = capitalizedString;
    const place_event = new Event('change');
    place_option.dispatchEvent(place_event);

    let download_speed = document.querySelector('.dynamic-data').getAttribute('data-downloadSpeed').split(' ')[0];
    speed_option.value = download_speed;
    const speed_event = new Event('change');
    speed_option.dispatchEvent(speed_event);

    $('.verify-service-number').on('click', (e) => {
      const API_URL = "https://openserve.novux.co.za";
      $(e.target).parents(".Server_number").find(".prepaid_server_number").attr("disabled", "disabled");
      $(e.target).parents(".Server_number").find(".verify-service-number").attr("disabled", "disabled");
      $(e.target).parents(".Server_number").find(".verify-service-number i").removeClass("hidden");
      $(e.target).parents(".Server_number").find(".verify-service-number span").addClass("hidden");
      e.preventDefault();
      console.log('verify service number');
      const serviceNumber = $('.prepaid_server_number').val();
      console.log(serviceNumber);
      if (!serviceNumber) return;
      const formData = new FormData();
      formData.append('serviceId', serviceNumber);
      fetch(API_URL + '/api/getprepaidservice', {
        method: 'POST', 
        body: formData
      })
        .then(res => res.json())
        .then(data => {
          $(e.target).parents(".Server_number").find(".verify-service-number i").addClass("hidden");
          $(e.target).parents(".Server_number").find(".verify-service-number span").removeClass("hidden");
          $(e.target).parents(".Server_number").find(".prepaid_server_number").removeAttr("disabled");
          if ( data.success ) {
            $(e.target).parents(".Server_number").find(".verify-service-number span").text("Verified!").removeClass("hidden");
            $(".product-form .product-form__buttons .product-form__submit").attr('disabled', false);
            $(".product-form .server_number_error").text("");
          }
          else {
            $(e.target).closest(".product-form").find(".verify-service-number").attr("disabled", "disabled").removeClass("align-self-end").addClass("align-self-center");
            $(".product-form .product-form__buttons .product-form__submit").attr('disabled', true);
            $(".product-form .server_number_error").text(data.error);
          }
        })
        .catch(error => {
          $(e.target).parents(".Server_number").find(".prepaid_server_number").removeAttr("disabled");
          $(e.target).parents(".Server_number").find(".verify-service-number").removeAttr("disabled");
          $(e.target).parents(".Server_number").find(".verify-service-number i").addClass("hidden");
          $(e.target).parents(".Server_number").find(".verify-service-number span").removeClass("hidden");
          console.error(error);
        });
    });
  
  }
  // click event when click on order now event
  if(document.body.classList.contains('page--coverage')){
   let has_class = setInterval(() => {
      if(document.querySelector('.has_product_available') != null || document.querySelector('.has_product_available') != undefined){
        console.log("class find");
        theme.coverage_orderNow_click();
        var parentDiv = document.querySelector('#newAddressBtn .divAlignCenter');
console.log('parentDiv',parentDiv);
        // Check if the parent element exists
        if (parentDiv) {
            // Add the 'disabled' class to the parent element
            parentDiv.classList.remove('enabled');
            parentDiv.classList.add('disabled');
            console.log('parentDivif',parentDiv);
            // Optionally, you can disable any child elements if needed
            var link = parentDiv.querySelector('#confirmAdr');
            console.log('link',link);
            if (link) {
                link.style.pointerEvents = 'none'; // Prevent interaction
                link.style.cursor = 'not-allowed';  // Change cursor
            }
        }

        clearInterval(has_class);
      }
    }, 1000);
  }
  if(document.body.classList.contains('template-product')){
    console.warn('pdp pageee')
    if(localStorage.getItem('locationData') != null){
      let location_data = JSON.parse(localStorage.getItem('locationData'));
      // formData.append(`[properties][_shop]`, 'shopname');
      const product_form = document.querySelector('.shopify-payment-button')?.closest('form');
      let location_input = `<input type="hidden" name="properties[_shop]" value="${location_data.shop}">
      <input type="hidden" name="properties[_country]" value="${location_data.country}">
      <input type="hidden" name="properties[_city]" value="${location_data.city}">
      <input type="hidden" name="properties[_buildingName]" value="${location_data.buildingName}">
      <input type="hidden" name="properties[_floor]" value="${location_data.floor}">
      <input type="hidden" name="properties[_unit]" value="${location_data.unit}">
      <input type="hidden" name="properties[_amid]" value="${location_data.amid}">
      <input type="hidden" name="properties[_suburb]" value="${location_data.suburb}">
      <input type="hidden" name="properties[_street1]" value="${location_data.street1}">
      <input type="hidden" name="properties[_region]" value="${location_data.region}">
      <input type="hidden" name="properties[_longitude]" value="${location_data.longitude}">
      <input type="hidden" name="properties[_latitude]" value="${location_data.latitude}">`
      if(product_form != undefined){
        product_form.insertAdjacentHTML('beforeend', location_input);
      }
    }
  }
  //create ticket button click 
  document.querySelector('.creat-ticket-btn')?.addEventListener("click", function(){
    if(window.isCustomer === 'true'){
      document.getElementById('create_form').classList.add('has_popup_open');
      document.body.classList.add('body_overlay');
      theme.ticket_form_submit_api();
    }else{
      const parentElement = document.querySelector('.creat-ticket-button-wrapper');
      if(document.getElementById('customer-error') == null){
        const newElement = document.createElement('div');
        newElement.textContent = 'please login to the account to create ticket'; // Optionally, set some content
        newElement.setAttribute('id', 'customer-error');
        // Get the first child of the parent element
        const firstChild = parentElement.firstChild;
        // Insert the new element before the first child
        parentElement.insertBefore(newElement, firstChild);
      }
    }
  })
  // if customer login then display ticket data append
  let data_suffix = document.body.getAttribute('data-suffix');
  if(window.isCustomer === 'true' && data_suffix === 'ticket-form'){
    console.log('isCustomer', window.isCustomer);
    theme.ticket_data_list_api();
  }
  // ticket form close on click
  document.querySelector('.close-form-popup')?.addEventListener('click',function(){
    document.getElementById('create_form').classList.remove('has_popup_open');
    document.body.classList.remove('body_overlay'); 
  });
  //Rica documents submit api call
  if(data_suffix == 'document-submit'){
    theme.rica_document_submit();
  }
  if(window.isCustomer == true && window.customer_hasSubmitted == false || window.customer_hasSubmitted == '' ){
    theme.rica_after_submit();
  }
  /* Subscription flow custom field pass start */
  // if(data_suffix == 'sf-checkout'){
  //   theme.sf_checkout();
  // }
  // if(document.body.classList.contains('template-product')){
    theme.append_custom_data_subscription();
  // }
  /* Subscription flow custom field pass end */
  /* Custom thank page loader stop start */
  if(data_suffix == 'custom-thank-you'){
    setTimeout(() => {
      document.getElementById('custom-thank-you-loader').style.display = 'none';
      document.querySelector('.custom-thankyou-inner-main').style.display = 'block';
    }, 2000);
  }
  /* Custom thank page loader stop end */
});